import React from "react";
import {CascadeItemContainer, CascadeMessage} from "../../styles/styles";
import IndicatorCascadeCard from "./IndicatorCascadeCard";


const IndicatorsCascadeList = ({indicators, fromProject,objective}) => {

    return(
        <CascadeItemContainer>
            {
                indicators.length > 0 ?
                    (indicators.map((i) => {
                        return <IndicatorCascadeCard
                            indicator={i}
                            key={i.id}
                            fromProject={fromProject}
                            objective={objective}
                        />
                    })) :
                    <CascadeMessage> Il n'y a pas encore de résultat clé pour cet objectif </CascadeMessage>
            }
        </CascadeItemContainer>
    )
}

export default IndicatorsCascadeList